export const MEDIA_PLATFORM_DOMAIN = 'wixmp-3dbd5cb16bb136182e099f78.wixmp.com';
export const FILES_MEDIA_PLATFORM_HOST = "https://" + MEDIA_PLATFORM_DOMAIN;
export const IMAGES_MEDIA_PLATFORM_HOST = "https://images-" + MEDIA_PLATFORM_DOMAIN;
//# sourceMappingURL=endpoints.js.map